import {
  AlertDialog as BaseAlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '~/components/ui/AlertDialog'

interface ConfirmationDialogProps extends React.PropsWithChildren {
  title: string
  children: React.ReactNode
  onConfirm: () => void
  onCancel?: () => void
  open: boolean
  onOpenChange: (open: boolean) => void
  confirmLabel?: string
  cancelLabel?: string
}

export function ConfirmationDialog({
  title,
  children,
  onConfirm,
  onCancel,
  open,
  onOpenChange,
  confirmLabel = 'Continue',
  cancelLabel = 'Cancel'
}: ConfirmationDialogProps) {
  return (
    <BaseAlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{children}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {onCancel && (
            <AlertDialogCancel onClick={onCancel}>{cancelLabel}</AlertDialogCancel>
          )}
          <AlertDialogAction onClick={onConfirm}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </BaseAlertDialog>
  )
}
